/**
 * Owner, 25.10.2026: «если программу в инверторе поменяли вручную — не
 * писать, показать предупреждение клиенту и админу, ждать решения». A read
 * of the inverter's settings showed a program other than Phage's latest
 * write: nothing is written to the inverter until the client or the
 * administrator brings Phage's program back; to keep the inverter's own,
 * nothing is done (disconnecting does not change it either).
 */
import type { SiteResponse } from 'shared';

import { useResumeProgram } from '../hooks/use-sites.js';
import { useLocale } from '../i18n/locale-context.js';
import { errorText } from './errors.js';
import { fmtDateTime } from './format.js';

export function ProgramChangedWarning({ site }: { site: SiteResponse }) {
  const { t, tf } = useLocale();
  const resume = useResumeProgram(site.id);
  const changed = site.inverter_settings.program_changed;
  if (!changed) return null;
  return (
    <div data-testid="program-changed">
      <p className="err" role="alert">
        {tf('site.prog_changed', { at: fmtDateTime(changed.at, site.timezone) })}
      </p>
      {changed.change ? (
        <p className="sub">{tf('site.prog_changed.diff', { change: changed.change })}</p>
      ) : null}
      <p className="hint">{t('site.prog_changed.keep')}</p>
      <div className="actions">
        <button
          type="button"
          className="btn primary"
          disabled={resume.isPending}
          onClick={() => resume.mutate()}
        >
          {t('site.prog_changed.resume')}
        </button>
        <span className="sub" style={{ alignSelf: 'center' }}>
          {t('site.prog_changed.resume_sub')}
        </span>
      </div>
      {resume.error ? (
        <p className="err" role="alert">
          {tf('site.prog_changed.err', { msg: errorText(resume.error, tf) })}
        </p>
      ) : null}
    </div>
  );
}
